import { action, makeObservable, observable } from "mobx";


export class PopStore {
    rootStore;
    isSlideOpen = false;
    buttonTitle = '';
    title = '';
    body = '';
    okAction = null;
    cancelAction = null;
    showCancel = true;
    autoOpen = false;
    constructor(root) {
        makeObservable(this, {
            isSlideOpen: observable,
            buttonTitle: observable,
            title: observable,
            body: observable,
            okAction: observable,
            cancelAction: observable,
            showCancel: observable,
            autoOpen: observable,
            
            setSlideOpen: action,
            setSlideWithOpen: action,
            setSlide: action,
        });

        this.rootStore = root;
        this.isSlideOpen = false;
        this.buttonTitle = '';
        this.title = '';
        this.body = '';
        this.okAction = null;
        this.cancelAction = null;
        this.showCancel = true;
        this.autoOpen = false;
    }

    setSlideOpen(isOpen) {
        this.isSlideOpen = isOpen;
    }

    setSlideWithOpen({ buttonTitle, title, body, okAction, cancelAction, showCancel = true, autoOpen = false }) {
        this.buttonTitle = buttonTitle;
        this.title = title;
        this.body = body;
        this.okAction = okAction;
        this.cancelAction = cancelAction;
        this.showCancel = showCancel;
        this.autoOpen = autoOpen;
        this.isSlideOpen = true;
    }

    setSlide({ buttonTitle, title, body, okAction, cancelAction, showCancel = true, autoOpen = false }) {
        this.buttonTitle = buttonTitle;
        this.title = title;
        this.body = body;
        this.okAction = okAction;
        this.cancelAction = cancelAction;
        this.showCancel = showCancel;
        this.autoOpen = autoOpen;
    } 
}